import { routerMutex } from "@bebit/store";
import { DatePickerPreset } from "@bebit/types";
import { computed, ComputedRef } from "vue";
import { useRouter, useRoute } from "vue-router";
import { convertPeriodToRouteQueryFormat } from "@host/utils/report-period";

export function usePresetUrlParams() {
  const route = useRoute();
  const router = useRouter();

  const presetFromUrl: ComputedRef<DatePickerPreset | undefined> = computed(() => {
    const period = (route.query.period as string) || undefined;
    if (period === DatePickerPreset.Last28Days || period === DatePickerPreset.Last7Days) return period;
    return undefined;
  });

  function setPresetToUrl(value: DatePickerPreset) {
    routerMutex.runExclusive(async () => {
      await router.replace({ query: { ...route.query, period: convertPeriodToRouteQueryFormat(value) } });
    });
  }

  return { presetFromUrl, setPresetToUrl };
}
